import NewHeader from 'components/NewHeader';
import { AboutCheckoutProduct } from 'components/About/index';
import HeaderSpaceWrapper from 'components/Common/HeaderSpaceWrapper';
import Footer from 'components/Footer/Footer';
import {
  BodyTextM,
  BodyTextS,
  H2KR,
  SubtitleL,
  SubtitleM,
} from 'global-styles';
import { BBINDIGO, GRAY30, GRAY50 } from 'global-styles';
import { useRemoveScrollTop } from 'hooks/useRemoveScrollTop';
import { en, ko } from 'locale/privacyPolicy';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

const PrivacyPolicyPage = () => {
  const { locale } = useRouter();
  const articleArray = locale === 'en' ? en.articles : ko.articles;

  useRemoveScrollTop();

  return (
    <PrivacyPolicyPageContainer>
      <Head>
        <title>Privacy Policy - BLUEDOT</title>
        <meta
          name="description"
          content={locale === 'en' ? en.midDesc : ko.midDesc}
          key="description"
        />
        <meta
          property="og:description"
          content={locale === 'en' ? en.midDesc : ko.midDesc}
          key="og:description"
        />
        <meta
          property="twitter:description"
          content={locale === 'en' ? en.midDesc : ko.midDesc}
          key="twitter:description"
        />
      </Head>
      <NewHeader isScrolled />
      <HeaderSpaceWrapper />
      {/* <div className="h-wrapper" /> */}
      <div className="inner-container">
        <div className="top-area">
          <H2KR className="title">
            {locale === 'en'
              ? 'BLUEDOT Privacy Policy'
              : '블루닷 개인정보처리방침'}
          </H2KR>
          <SubtitleL className="last-up">
            {locale === 'en'
              ? '2022.09.07 last updated'
              : '2022.09.07 마지막으로 업데이트 됨'}
          </SubtitleL>
          <BodyTextM className="desc">
            {locale === 'en' ? en.midDesc : ko.midDesc}
          </BodyTextM>
        </div>

        <div className="policy-area">
          {articleArray.map(art => (
            <div className="pol-box" key={art.title}>
              <SubtitleM className="pol-title">{art.title}</SubtitleM>
              <BodyTextS
                as="pre"
                className="pol-desc"
                style={{ fontWeight: 400 }}
              >
                {art.desc}
              </BodyTextS>
            </div>
          ))}
        </div>
      </div>
      <AboutCheckoutProduct />
      <Footer />
    </PrivacyPolicyPageContainer>
  );
};

export default PrivacyPolicyPage;

export const PrivacyPolicyPageContainer = styled.section`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  overflow-x: hidden;

  & > .inner-container {
    text-align: center;
    @media screen and (min-width: 1440px) {
      width: 100%;
      max-width: 1048px;
      margin: 142px auto 202px;
    }
    @media screen and (min-width: 1240px) and (max-width: 1439px) {
      width: calc(100% - 192px);
      margin: 142px 96px 202px;
    }
    @media screen and (min-width: 905px) and (max-width: 1239px) {
      width: calc(100% - 112px);
      margin: 142px 56px 202px;
    }
    @media screen and (min-width: 600px) and (max-width: 904px) {
      width: calc(100% - 64px);
      margin: 142px 32px 202px;
    }
    @media screen and (max-width: 599px) {
      width: calc(100% - 32px);
      margin: 142px 16px 202px;
    }
  }
  .top-area {
    text-align: left;
  }
  .last-up {
    color: ${GRAY50};
    text-align: center;
  }
  .title {
    text-align: center;
    color: ${BBINDIGO};
    margin-bottom: 8px;
  }
  .desc {
    color: ${GRAY30};
    margin: 96px 0;
  }
  .pol-box {
    color: ${GRAY50};
  }
  .pol-box + .pol-box {
    margin-top: 32px;
  }
  .pol-title {
    color: ${GRAY30};
  }
  .pol-desc {
    color: ${GRAY50};
    white-space: pre-line;
    margin-top: 8px;
  }
  .policy-area {
    text-align: left;
  }
`;
